import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

const LoadPanel = ({ visible }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1, // Magasabb z-index, hogy minden fölé kerüljön
        backdropFilter: 'blur(5px)', // iOS-szerű üveghatás
        backgroundColor: 'rgba(0, 0, 0, 0.3)', // Átlátszó sötét háttér
      }}
      open={visible}
    >
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};

export default LoadPanel;
